import slugify from 'slugify';

export const toCapitalize = string => {
  if (!string) {
    return;
  }
  let strArray = string.split(' ');
  strArray = strArray.map(str => str.charAt(0).toUpperCase() + str.slice(1));
  strArray = strArray.join(' ');
  return strArray;
};

export const toNormalize = string => {
  if (!string) {
    return;
  }
  return slugify(string).toLowerCase();
};



// WEBPACK FOOTER //
// ./src/Common/string/index.js